<template>
    <div>
        <div class="form-group">
            <input type="text"
                   autocomplete="off"
                   class="form-control"
                   :placeholder="Lang.get('js.search')"
                   v-model="query">
            <button class="btn-search btn btn-primary" @click="search" :disabled="query === ''">
                <i class="fa fa-search"></i>
            </button>
        </div>
    </div>
</template>

<script>

    export default {
        name: "product-search",
        data() {
            return {
                defaultLanguage,
                selected: 0,
                items: [],
                query: '',
                show: false,
                loading: false,
                searchUrl: '/search/fraze-{0}',
                Lang,
            }
        },
        watch: {
            query: {
                handler: _.debounce(
                    function () {
                        this.getData();
                    }, 500
                )
            },
        },
        methods: {
            urlProductSearch(url) {
                if (this.Lang.locale !== this.defaultLanguage) {
                    url = '/' + this.Lang.locale + url;
                }
                return url;
            },
            arrowsUpPress() {
                let currentSelected = this.selected - 1;
                if (this.items.hasOwnProperty(currentSelected)) {
                    this.selected = this.selected - 1;
                } else {
                    this.selected = this.items.length - 1;
                }
            },
            arrowsDownPress() {
                let currentSelected = this.selected + 1;
                if (this.items.hasOwnProperty(currentSelected)) {
                    this.selected = this.selected + 1;
                } else {
                    this.selected = 0;
                }
            },
            goToLink() {
                let selectedItem = this.items[this.selected];
                let url = '';

                url = this.searchUrl.format(this.query);

                location = url;
            },
            hideResult() {
                this.show = false;
            },
            showResult() {
                this.show = true;
            },
            getData() {

            },
            search() {
                location = this.urlProductSearch(this.searchUrl).format(this.query);
            }
        },
        mounted() {
            document.addEventListener('keydown', (e) => {
                switch (e.which) {
                    // up
                    case 38:
                        e.preventDefault();
                        this.arrowsUpPress();
                        break;
                    // down
                    case 40:
                        e.preventDefault();
                        this.arrowsDownPress();
                        break;
                    // enter
                    case 13:
                        e.preventDefault();
                        this.goToLink();
                        break;
                    default:
                        return;
                }
            });
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/laboratory/LaboratorySearch.vue